"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateProgress;

function calculateProgress(_ref) {
  var offset = _ref.offset,
      pageX = _ref.pageX,
      offsetWidth = _ref.offsetWidth,
      end = _ref.end,
      start = _ref.start,
      step = _ref.step,
      roundingAccuracy = _ref.roundingAccuracy;
  var progress, value;
  progress = (pageX - offset.left) / offsetWidth * 100;
  progress = progress < 0.01 ? 0 : progress;
  progress = progress > 99.99 ? 100 : progress;
  value = (end - start) * (progress / 100) + start;

  if (!isNaN(step) && step > 0 && value > start && value < end) {
    value = Math.round(value / step) * step;
  }

  value = value.toFixed(roundingAccuracy);

  if (!isNaN(start) && value < start) {
    value = start;
  } else if (!isNaN(end) && value > end) {
    value = end;
  }

  return value;
}